import Vue from 'vue'
import VueRouter from 'vue-router'
import Cookie from 'js-cookie';

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function (loaction) {
    return routerPush.call(this, loaction).catch(err => { })
}

Vue.use(VueRouter)

import Index from '@/pages/Index'
import Firstpage from '@/pages/Firstpage'
import Product from '@/pages/Product'
import ProductAMH from '@/pages/product/Product_amh'
import ProductTwt from '@/pages/product/Product_twt'
import ProductLh from '@/pages/product/Product_lh'
import ProductAMHmp4 from '@/pages/product/Product_amh_mp4'
import ProductCebeimp4 from '@/pages/product/Product_cebei_mp4'
import Product_cb_privacy from '@/pages/product/Product_cb_privacy'
import Information from '@/pages/Information'
import Aboutus from '@/pages/Aboutus'
import Cooperation from '@/pages/Cooperation'

import Information250320 from '@/pages/news/250320'
import Information200807 from '@/pages/news/200807'
import Information200625 from '@/pages/news/200625'
import Information180713 from '@/pages/news/180713'

import Login from '@/pages/admin/Login'
import Home from '@/pages/admin/Home'


const router = new VueRouter({
    mode: 'history',
    // base:"/",
    routes: [
        {
            path: '/',
            component: Index,
            meta: { isOpen: true },
            // redirect:'/',
            //官网页面
            children: [
                { path: '/', component: Firstpage, name: 'firstpage', meta: { isOpen: true }, },
                { path: '/product', component: Product, name: 'product', meta: { isOpen: true }, },
                { path: '/product/amh', component: ProductAMH, name: 'productamh', meta: { isOpen: true }, },
                { path: '/product/twt', component: ProductTwt, name: 'producttwt', meta: { isOpen: true }, },
                { path: '/product/lh', component: ProductLh, name: 'productlh', meta: { isOpen: true }, },
                { path: '/product/cb/privacy', component: Product_cb_privacy, name: 'productcbprivacy', meta: { isOpen: true }, },               
                { path: '/information', component: Information, name: 'information', meta: { isOpen: true }, },
                { path: '/aboutus', component: Aboutus, name: 'aboutus', meta: { isOpen: true }, },
                { path: '/cooperation', component: Cooperation, name: 'cooperation', meta: { isOpen: true }, },
                { path: '/information/180713', component: Information180713, name: 'information180713', meta: { isOpen: true }, },
                { path: '/information/200625', component: Information200625, name: 'information200625', meta: { isOpen: true }, },
                { path: '/information/200807', component: Information200807, name: 'information200807', meta: { isOpen: true }, },
                { path: '/information/250320', component: Information250320, name: 'information250320', meta: { isOpen: true }, },
            ]
        },
        {
            path: '/views/amh.mp4',
            component: ProductAMHmp4,
            meta: { isOpen: true },
        },
        {
            path: '/views/cebei.mp4',
            component: ProductCebeimp4,
            meta: { isOpen: true },
        },
        {
            path: '/login',
            name: 'login',
            meta: { isOpen: true },
            component: Login
        },
        {
            path: '/home',
            component: Home,
            name: 'home',
            redirect: '/home/main',
            meta: { isClose: true },
        }

    ],
})

router.beforeEach((to, from, next) => {
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0

    const token = Cookie.get('token')
    if (token && to.name === 'login') {
        next({ name: 'home' })
    }
    if (to.meta.isOpen) {
        next()
    } else {
        if (!token && to.name !== 'login') {
            next({ name: 'login' })
        } else {
            //判断token有效
            next()
        }
    }

})

export default router